/**
 * recordStatusColor
 *
 * Maps each EntityRecord lifecycle status to an Ant Design Tag colour, so the
 * records list and any status chips render a consistent badge. UI-only (not
 * persisted); mirrors the colour-per-state convention of `formStateDescription`
 * in types/Client.Parameters.types.ts.
 */
import { RecordStatus } from '#types/System.Parameters.types';

export const recordStatusColor: Record<RecordStatus, string> = {
    [RecordStatus.Active]: 'green',
    [RecordStatus.Pending]: 'gold',
    [RecordStatus.Inactive]: 'default',
};
